import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSONObject: any;
};

export type ActivateWorkflowTypeResponse = {
  __typename?: 'ActivateWorkflowTypeResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AdminProcessingStatistics = {
  __typename?: 'AdminProcessingStatistics';
  adminRejected: Scalars['Int'];
  manuallyProcessed: Scalars['Int'];
  processedToday: Scalars['Int'];
  totalRequiringAction: Scalars['Int'];
};

export type Answer = {
  __typename?: 'Answer';
  selectedOptionLabels?: Maybe<Array<Scalars['String']>>;
  text?: Maybe<Scalars['String']>;
};

export type AnswerInput = {
  selectedOptionLabels?: InputMaybe<Array<Scalars['String']>>;
  text?: InputMaybe<Scalars['String']>;
};

export type AnswerWithText = {
  __typename?: 'AnswerWithText';
  selectedOptions?: Maybe<Array<SelectedOption>>;
  text?: Maybe<Scalars['String']>;
};

export type AttemptResponse = {
  __typename?: 'AttemptResponse';
  answer: Answer;
  attemptId: Scalars['ID'];
  awardedPoints: Scalars['Int'];
  isCorrect: Scalars['Boolean'];
  pointStatus?: Maybe<PointTransactionStatus>;
  quizId: Scalars['ID'];
  submittedAt: Scalars['DateTime'];
};

export type BatchUpdateQuizPointsInput = {
  difficulty: Difficulty;
  points: Scalars['Int'];
  status?: InputMaybe<QuizStatus>;
};

export type BatchUpdateQuizPointsResponse = {
  __typename?: 'BatchUpdateQuizPointsResponse';
  difficultyPoints: DifficultyPointsResponse;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  updatedCount: Scalars['Int'];
};

export type ChoiceInput = {
  isCorrect: Scalars['Boolean'];
  label: Scalars['String'];
  text: Scalars['String'];
};

export type ChoiceResponse = {
  __typename?: 'ChoiceResponse';
  id: Scalars['ID'];
  isCorrect: Scalars['Boolean'];
  label: Scalars['String'];
  text: Scalars['String'];
};

export type CreateDifficultyInput = {
  code: Scalars['String'];
  label: Scalars['String'];
  order: Scalars['Int'];
  points: Scalars['Int'];
};

export type CreateQuizInput = {
  awardedPoints?: Scalars['Int'];
  choices?: InputMaybe<Array<ChoiceInput>>;
  difficultyId?: InputMaybe<Scalars['ID']>;
  explanation: Scalars['String'];
  hint?: InputMaybe<Scalars['String']>;
  shortAnswerSpec?: InputMaybe<ShortAnswerSpecInput>;
  sourceMaterialId?: InputMaybe<Scalars['ID']>;
  stem: Scalars['String'];
  type: QuizType;
};

export type CreateSourceMaterialInput = {
  contentType: Scalars['String'];
  fileSize?: InputMaybe<Scalars['Int']>;
  filename: Scalars['String'];
  title: Scalars['String'];
};

export type CreateSourceMaterialResponse = {
  __typename?: 'CreateSourceMaterialResponse';
  expiresAt: Scalars['String'];
  id: Scalars['ID'];
  uploadUrl: Scalars['String'];
};

export type CreateWorkflowTypeInput = {
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parameterSchema: Scalars['JSONObject'];
  webhookUrl: Scalars['String'];
};

export type CreateWorkflowTypeResponse = {
  __typename?: 'CreateWorkflowTypeResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  workflowTypeId: Scalars['String'];
};

export type DailyQuizzesResponse = {
  __typename?: 'DailyQuizzesResponse';
  date: Scalars['String'];
  quizzes: Array<QuizWithUserStatus>;
  todayCorrectCount: Scalars['Int'];
};

export type DeactivateWorkflowTypeResponse = {
  __typename?: 'DeactivateWorkflowTypeResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum Difficulty {
  Easy = 'EASY',
  Hard = 'HARD',
  Medium = 'MEDIUM'
}

export type DifficultyPointsResponse = {
  __typename?: 'DifficultyPointsResponse';
  difficulty: Difficulty;
  points: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type DifficultyResponse = {
  __typename?: 'DifficultyResponse';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
  order: Scalars['Int'];
  points: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

/** Domain object types that can trigger workflows */
export enum DomainObjectType {
  Draft = 'DRAFT',
  GenerationJob = 'GENERATION_JOB',
  OriginalPost = 'ORIGINAL_POST',
  Post = 'POST',
  Quiz = 'QUIZ',
  SourceMaterial = 'SOURCE_MATERIAL'
}

/** Workflow execution status */
export enum ExecutionStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export type ExecutionStatusSummary = {
  __typename?: 'ExecutionStatusSummary';
  count: Scalars['Int'];
  status: ExecutionStatus;
};

export type ExplanationResponse = {
  __typename?: 'ExplanationResponse';
  attemptId: Scalars['ID'];
  explanationText: Scalars['String'];
  quizId: Scalars['ID'];
  selectedOptionLabels?: Maybe<Array<Scalars['String']>>;
  viewVariant: Scalars['String'];
};

export type FinalizeUploadInput = {
  id: Scalars['ID'];
};

export type GenerateQuizInput = {
  difficulty?: Difficulty;
  /** MCQ(다지선다) 퀴즈 개수 */
  mcqCount?: Scalars['Int'];
  /** OX 퀴즈 개수 */
  oxCount?: Scalars['Int'];
  /** 주관식 퀴즈 개수 */
  shortCount?: Scalars['Int'];
  sourceMaterialId: Scalars['ID'];
};

export type GenerateQuizResponse = {
  __typename?: 'GenerateQuizResponse';
  jobId: Scalars['ID'];
  message: Scalars['String'];
  status: Scalars['String'];
};

export enum GenerationJobStatus {
  Deleted = 'DELETED',
  Drafted = 'DRAFTED',
  DraftRequested = 'DRAFT_REQUESTED',
  DraftRequestFailed = 'DRAFT_REQUEST_FAILED',
  New = 'NEW',
  OnHold = 'ON_HOLD',
  Rejected = 'REJECTED',
  Selected = 'SELECTED'
}

export type GenerationJobSummary = {
  __typename?: 'GenerationJobSummary';
  correlationId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  generatedCount: Scalars['Int'];
  id: Scalars['ID'];
  requestedAt: Scalars['DateTime'];
  status: GenerationJobStatus;
};

export type HistoryConnection = {
  __typename?: 'HistoryConnection';
  items: Array<HistoryItem>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  summary: HistorySummary;
  total: Scalars['Int'];
};

export type HistoryDetail = {
  __typename?: 'HistoryDetail';
  answer: AnswerWithText;
  attemptId: Scalars['ID'];
  awardedPoints: Scalars['Int'];
  correctAnswer: AnswerWithText;
  correctRate: Scalars['Float'];
  explanationText: Scalars['String'];
  isCorrect: Scalars['Boolean'];
  questionText: Scalars['String'];
  quizId: Scalars['ID'];
  tags: Array<Scalars['String']>;
};

export type HistoryFilterInput = {
  q?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type HistoryItem = {
  __typename?: 'HistoryItem';
  attemptId: Scalars['ID'];
  attemptedAt: Scalars['DateTime'];
  awardedPoints: Scalars['Int'];
  isCorrect: Scalars['Boolean'];
  questionText?: Maybe<Scalars['String']>;
  quizId: Scalars['ID'];
  tags: Array<Scalars['String']>;
};

export enum HistorySort {
  AttemptCount = 'ATTEMPT_COUNT',
  Oldest = 'OLDEST',
  Recent = 'RECENT'
}

export type HistorySummary = {
  __typename?: 'HistorySummary';
  todayCorrectCount: Scalars['Int'];
  totalAttempts: Scalars['Int'];
  totalPoints: Scalars['Int'];
};

export enum ManualProcessingType {
  ManualPointGrant = 'MANUAL_POINT_GRANT',
  SkipProcessing = 'SKIP_PROCESSING'
}

export type Mutation = {
  __typename?: 'Mutation';
  activateQuiz: QuizResponse;
  activateWorkflowType: ActivateWorkflowTypeResponse;
  batchUpdateQuizPoints: BatchUpdateQuizPointsResponse;
  /** Create a new difficulty level (Admin only) */
  createDifficulty: DifficultyResponse;
  createQuiz: QuizResponse;
  createSourceMaterial: CreateSourceMaterialResponse;
  createWorkflowType: CreateWorkflowTypeResponse;
  /** Deactivate a difficulty level (Admin only). Cannot deactivate if quizzes are using it. */
  deactivateDifficulty: DifficultyResponse;
  deactivateQuiz: QuizResponse;
  deactivateWorkflowType: DeactivateWorkflowTypeResponse;
  deleteQuiz: Scalars['Boolean'];
  deleteSourceMaterial: Scalars['Boolean'];
  finalizeSourceMaterialUpload: SourceMaterialResponse;
  generateQuizzes: GenerateQuizResponse;
  processPointTransaction: ProcessPointTransactionResponse;
  rejectQuiz: QuizResponse;
  retrySourceMaterialUpload: CreateSourceMaterialResponse;
  submitAttempt: SubmitAttemptPayload;
  /** Update a difficulty level (Admin only) */
  updateDifficulty: DifficultyResponse;
  updateQuiz: QuizResponse;
  updateSourceMaterial: SourceMaterialResponse;
  updateWorkflowType: UpdateWorkflowTypeResponse;
};


export type MutationActivateQuizArgs = {
  id: Scalars['ID'];
};


export type MutationActivateWorkflowTypeArgs = {
  id: Scalars['String'];
};


export type MutationBatchUpdateQuizPointsArgs = {
  input: BatchUpdateQuizPointsInput;
};


export type MutationCreateDifficultyArgs = {
  input: CreateDifficultyInput;
};


export type MutationCreateQuizArgs = {
  input: CreateQuizInput;
};


export type MutationCreateSourceMaterialArgs = {
  input: CreateSourceMaterialInput;
};


export type MutationCreateWorkflowTypeArgs = {
  input: CreateWorkflowTypeInput;
};


export type MutationDeactivateDifficultyArgs = {
  id: Scalars['ID'];
};


export type MutationDeactivateQuizArgs = {
  id: Scalars['ID'];
};


export type MutationDeactivateWorkflowTypeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteQuizArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSourceMaterialArgs = {
  id: Scalars['ID'];
};


export type MutationFinalizeSourceMaterialUploadArgs = {
  input: FinalizeUploadInput;
};


export type MutationGenerateQuizzesArgs = {
  input: GenerateQuizInput;
};


export type MutationProcessPointTransactionArgs = {
  input: ProcessPointTransactionInput;
};


export type MutationRejectQuizArgs = {
  id: Scalars['ID'];
};


export type MutationRetrySourceMaterialUploadArgs = {
  id: Scalars['ID'];
};


export type MutationSubmitAttemptArgs = {
  answer: AnswerInput;
  quizId: Scalars['String'];
};


export type MutationUpdateDifficultyArgs = {
  id: Scalars['ID'];
  input: UpdateDifficultyInput;
};


export type MutationUpdateQuizArgs = {
  id: Scalars['ID'];
  input: UpdateQuizInput;
};


export type MutationUpdateSourceMaterialArgs = {
  id: Scalars['ID'];
  input: UpdateSourceMaterialInput;
};


export type MutationUpdateWorkflowTypeArgs = {
  id: Scalars['String'];
  input: UpdateWorkflowTypeInput;
};

export type PaginatedQuizResponse = {
  __typename?: 'PaginatedQuizResponse';
  items: Array<QuizResponse>;
  meta: PaginationMeta;
};

export type PaginatedSourceMaterialResponse = {
  __typename?: 'PaginatedSourceMaterialResponse';
  items: Array<SourceMaterialResponse>;
  meta: PaginationMeta;
};

export type PaginationInput = {
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
};

export type PaginationMeta = {
  __typename?: 'PaginationMeta';
  limit: Scalars['Int'];
  page: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PointSummaryResponse = {
  __typename?: 'PointSummaryResponse';
  date: Scalars['String'];
  todayAwardedPoints: Scalars['Int'];
  todayCorrectCount: Scalars['Int'];
  totalPoints: Scalars['Int'];
};

export type PointTransactionDetail = {
  __typename?: 'PointTransactionDetail';
  adminProcessedAt?: Maybe<Scalars['DateTime']>;
  adminProcessedBy?: Maybe<Scalars['String']>;
  adminProcessingNote?: Maybe<Scalars['String']>;
  attemptId: Scalars['Int'];
  awardedPoints: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  manualProcessingType?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['DateTime']>;
  quizId: Scalars['Int'];
  retryCount: Scalars['Int'];
  status: PointTransactionStatus;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export enum PointTransactionStatus {
  AdminRejected = 'ADMIN_REJECTED',
  Failed = 'FAILED',
  ManuallyProcessed = 'MANUALLY_PROCESSED',
  NotApplicable = 'NOT_APPLICABLE',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type ProcessPointTransactionInput = {
  adminId: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  processingType: ManualProcessingType;
  transactionId: Scalars['Int'];
};

export type ProcessPointTransactionResponse = {
  __typename?: 'ProcessPointTransactionResponse';
  message: Scalars['String'];
  newStatus: PointTransactionStatus;
  success: Scalars['Boolean'];
  transactionId: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  activeQuizzes: Array<QuizResponse>;
  adminProcessingStatistics: AdminProcessingStatistics;
  dailyQuizzes: DailyQuizzesResponse;
  /** Get all difficulties (active only by default) */
  difficulties: Array<DifficultyResponse>;
  /** Get a difficulty by ID */
  difficulty: DifficultyResponse;
  difficultyPoint: DifficultyPointsResponse;
  difficultyPoints: Array<DifficultyPointsResponse>;
  draftQuizzes: Array<QuizResponse>;
  explanation: ExplanationResponse;
  getSourceMaterialDownloadUrl?: Maybe<Scalars['String']>;
  history: HistoryConnection;
  historyDetail: HistoryDetail;
  pointSummary: PointSummaryResponse;
  quiz: QuizResponse;
  quizzes: PaginatedQuizResponse;
  sourceMaterial: SourceMaterialResponse;
  sourceMaterials: PaginatedSourceMaterialResponse;
  transactionsByAdminId: Array<PointTransactionDetail>;
  transactionsRequiringAdminAction: Array<PointTransactionDetail>;
  workflowTypes: WorkflowTypeListType;
};


export type QueryDailyQuizzesArgs = {
  date?: InputMaybe<Scalars['String']>;
};


export type QueryDifficultiesArgs = {
  includeInactive?: Scalars['Boolean'];
};


export type QueryDifficultyArgs = {
  id: Scalars['ID'];
};


export type QueryDifficultyPointArgs = {
  difficulty: Difficulty;
};


export type QueryExplanationArgs = {
  attemptId: Scalars['String'];
};


export type QueryGetSourceMaterialDownloadUrlArgs = {
  id: Scalars['ID'];
};


export type QueryHistoryArgs = {
  filter?: InputMaybe<HistoryFilterInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<HistorySort>;
};


export type QueryHistoryDetailArgs = {
  attemptId: Scalars['String'];
};


export type QueryPointSummaryArgs = {
  date?: InputMaybe<Scalars['String']>;
};


export type QueryQuizArgs = {
  id: Scalars['ID'];
};


export type QueryQuizzesArgs = {
  filter?: InputMaybe<QuizFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<QuizSearchInput>;
  sort?: InputMaybe<QuizSortInput>;
};


export type QuerySourceMaterialArgs = {
  id: Scalars['ID'];
};


export type QuerySourceMaterialsArgs = {
  pagination?: InputMaybe<SourceMaterialPaginationInput>;
  search?: InputMaybe<SourceMaterialSearchInput>;
};


export type QueryTransactionsByAdminIdArgs = {
  adminId: Scalars['String'];
};


export type QueryWorkflowTypesArgs = {
  filters?: InputMaybe<WorkflowTypeFilters>;
  pagination?: InputMaybe<PaginationInput>;
};

export type QuizFilterInput = {
  difficultyId?: InputMaybe<Scalars['ID']>;
  /** 생성 번호 (generationJobId) */
  generationJobId?: InputMaybe<Scalars['ID']>;
  sourceMaterialId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<QuizStatus>;
  /** 문제 유형 (MCQ, OX, SHORT) */
  type?: InputMaybe<QuizType>;
};

export type QuizResponse = {
  __typename?: 'QuizResponse';
  awardedPoints: Scalars['Int'];
  choices?: Maybe<Array<ChoiceResponse>>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  difficultyLevel?: Maybe<DifficultyResponse>;
  explanation: Scalars['String'];
  generationJobId?: Maybe<Scalars['ID']>;
  hint?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  shortAnswerSpec?: Maybe<ShortAnswerSpecResponse>;
  sourceMaterialId?: Maybe<Scalars['ID']>;
  status: QuizStatus;
  stem: Scalars['String'];
  type: QuizType;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type QuizSearchInput = {
  /** 기간 필터 기준 (createdAt | updatedAt) */
  dateField?: InputMaybe<Scalars['String']>;
  /** 종료 날짜 (ISO 8601 형식) */
  endDate?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  /** 시작 날짜 (ISO 8601 형식) */
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/** 퀴즈 정렬 필드 */
export enum QuizSortField {
  AwardedPoints = 'AWARDED_POINTS',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type QuizSortInput = {
  /** 정렬할 필드 (awardedPoints, createdAt, updatedAt) */
  field?: InputMaybe<QuizSortField>;
  /** 정렬 순서 (asc, desc) */
  order?: InputMaybe<SortOrder>;
};

export enum QuizStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Drafted = 'DRAFTED',
  OnHold = 'ON_HOLD',
  Rejected = 'REJECTED'
}

export enum QuizType {
  Mcq = 'MCQ',
  Ox = 'OX',
  Short = 'SHORT'
}

export type QuizWithUserStatus = {
  __typename?: 'QuizWithUserStatus';
  awardedPoints: Scalars['Int'];
  choices?: Maybe<Array<ChoiceResponse>>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  difficultyLevel?: Maybe<DifficultyResponse>;
  explanation: Scalars['String'];
  generationJobId?: Maybe<Scalars['ID']>;
  hint?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAttempted: Scalars['Boolean'];
  isCorrect?: Maybe<Scalars['Boolean']>;
  shortAnswerSpec?: Maybe<ShortAnswerSpecResponse>;
  sourceMaterialId?: Maybe<Scalars['ID']>;
  status: QuizStatus;
  stem: Scalars['String'];
  type: QuizType;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userAttempt?: Maybe<AttemptResponse>;
};

export type SelectedOption = {
  __typename?: 'SelectedOption';
  label: Scalars['String'];
  text: Scalars['String'];
};

export type ShortAnswerSpecInput = {
  acceptableAnswers: Array<Scalars['String']>;
  typoTolerance?: Scalars['Int'];
};

export type ShortAnswerSpecResponse = {
  __typename?: 'ShortAnswerSpecResponse';
  acceptableAnswers: Array<Scalars['String']>;
  typoTolerance: Scalars['Int'];
};

/** 정렬 순서 */
export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SourceMaterialPaginationInput = {
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
};

export type SourceMaterialResponse = {
  __typename?: 'SourceMaterialResponse';
  contentType: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Int']>;
  generationHistory: Array<GenerationJobSummary>;
  id: Scalars['ID'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uploadStatus: UploadStatus;
};

export type SourceMaterialSearchInput = {
  search?: InputMaybe<Scalars['String']>;
};

export type SubmitAttemptPayload = {
  __typename?: 'SubmitAttemptPayload';
  attempt: AttemptResponse;
  explanation: ExplanationResponse;
};

export type UpdateDifficultyInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  points?: InputMaybe<Scalars['Int']>;
};

export type UpdateQuizInput = {
  awardedPoints?: InputMaybe<Scalars['Int']>;
  choices?: InputMaybe<Array<ChoiceInput>>;
  difficultyId?: InputMaybe<Scalars['ID']>;
  explanation?: InputMaybe<Scalars['String']>;
  hint?: InputMaybe<Scalars['String']>;
  shortAnswerSpec?: InputMaybe<ShortAnswerSpecInput>;
  /** 소스 자료 ID (수동 생성 퀴즈만 수정 가능) */
  sourceMaterialId?: InputMaybe<Scalars['ID']>;
  stem?: InputMaybe<Scalars['String']>;
};

export type UpdateSourceMaterialInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateWorkflowTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parameterSchema?: InputMaybe<Scalars['JSONObject']>;
  webhookUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateWorkflowTypeResponse = {
  __typename?: 'UpdateWorkflowTypeResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Source material upload status */
export enum UploadStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type WorkflowExecutionType = {
  __typename?: 'WorkflowExecutionType';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  durationMs?: Maybe<Scalars['Int']>;
  errorMessage?: Maybe<Scalars['String']>;
  executionId: Scalars['String'];
  payload: Scalars['JSONObject'];
  relatedObjectId: Scalars['String'];
  relatedObjectType: DomainObjectType;
  requestedAt: Scalars['DateTime'];
  result?: Maybe<Scalars['JSONObject']>;
  status: ExecutionStatus;
  updatedAt: Scalars['DateTime'];
  workflowTypeCode: Scalars['String'];
  workflowTypeId: Scalars['String'];
};

export type WorkflowTypeFilters = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type WorkflowTypeListType = {
  __typename?: 'WorkflowTypeListType';
  items: Array<WorkflowTypeType>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  total: Scalars['Int'];
};

export type WorkflowTypeType = {
  __typename?: 'WorkflowTypeType';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  executionCount: Scalars['Int'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  parameterSchema: Scalars['JSONObject'];
  updatedAt: Scalars['DateTime'];
  webhookUrl: Scalars['String'];
};

export type GetAdminQuizzesQueryVariables = Exact<{
  search?: InputMaybe<QuizSearchInput>;
  filter?: InputMaybe<QuizFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QuizSortInput>;
}>;


export type GetAdminQuizzesQuery = { __typename?: 'Query', quizzes: { __typename?: 'PaginatedQuizResponse', items: Array<{ __typename?: 'QuizResponse', id: string, stem: string, type: QuizType, awardedPoints: number, status: QuizStatus, sourceMaterialId?: string | null, generationJobId?: string | null, createdAt: any, updatedAt: any, updatedBy?: string | null, difficultyLevel?: { __typename?: 'DifficultyResponse', id: string, code: string, label: string, order: number, points: number } | null }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, total: number, totalPages: number } } };

export type GetAdminQuizQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAdminQuizQuery = { __typename?: 'Query', quiz: { __typename?: 'QuizResponse', id: string, stem: string, type: QuizType, awardedPoints: number, status: QuizStatus, explanation: string, hint?: string | null, sourceMaterialId?: string | null, generationJobId?: string | null, createdAt: any, updatedAt: any, updatedBy?: string | null, difficultyLevel?: { __typename?: 'DifficultyResponse', id: string, code: string, label: string, order: number, points: number } | null, choices?: Array<{ __typename?: 'ChoiceResponse', id: string, label: string, text: string, isCorrect: boolean }> | null, shortAnswerSpec?: { __typename?: 'ShortAnswerSpecResponse', acceptableAnswers: Array<string>, typoTolerance: number } | null } };

export type GetAdminActiveQuizzesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminActiveQuizzesQuery = { __typename?: 'Query', activeQuizzes: Array<{ __typename?: 'QuizResponse', id: string, stem: string, type: QuizType, awardedPoints: number, status: QuizStatus, sourceMaterialId?: string | null, generationJobId?: string | null, createdAt: any, updatedAt: any, difficultyLevel?: { __typename?: 'DifficultyResponse', id: string, code: string, label: string, order: number, points: number } | null }> };

export type GetAdminDraftQuizzesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminDraftQuizzesQuery = { __typename?: 'Query', draftQuizzes: Array<{ __typename?: 'QuizResponse', id: string, stem: string, type: QuizType, awardedPoints: number, status: QuizStatus, sourceMaterialId?: string | null, generationJobId?: string | null, createdAt: any, updatedAt: any, difficultyLevel?: { __typename?: 'DifficultyResponse', id: string, code: string, label: string, order: number, points: number } | null }> };

export type CreateAdminQuizMutationVariables = Exact<{
  input: CreateQuizInput;
}>;


export type CreateAdminQuizMutation = { __typename?: 'Mutation', createQuiz: { __typename?: 'QuizResponse', id: string, stem: string, type: QuizType, awardedPoints: number, status: QuizStatus, explanation: string, hint?: string | null, sourceMaterialId?: string | null, createdAt: any, updatedAt: any, difficultyLevel?: { __typename?: 'DifficultyResponse', id: string, code: string, label: string, order: number, points: number } | null, choices?: Array<{ __typename?: 'ChoiceResponse', id: string, label: string, text: string, isCorrect: boolean }> | null, shortAnswerSpec?: { __typename?: 'ShortAnswerSpecResponse', acceptableAnswers: Array<string>, typoTolerance: number } | null } };

export type UpdateAdminQuizMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateQuizInput;
}>;


export type UpdateAdminQuizMutation = { __typename?: 'Mutation', updateQuiz: { __typename?: 'QuizResponse', id: string, stem: string, type: QuizType, awardedPoints: number, status: QuizStatus, explanation: string, hint?: string | null, sourceMaterialId?: string | null, createdAt: any, updatedAt: any, difficultyLevel?: { __typename?: 'DifficultyResponse', id: string, code: string, label: string, order: number, points: number } | null, choices?: Array<{ __typename?: 'ChoiceResponse', id: string, label: string, text: string, isCorrect: boolean }> | null, shortAnswerSpec?: { __typename?: 'ShortAnswerSpecResponse', acceptableAnswers: Array<string>, typoTolerance: number } | null } };

export type DeleteAdminQuizMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAdminQuizMutation = { __typename?: 'Mutation', deleteQuiz: boolean };

export type ActivateAdminQuizMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActivateAdminQuizMutation = { __typename?: 'Mutation', activateQuiz: { __typename?: 'QuizResponse', id: string, status: QuizStatus, updatedAt: any } };

export type DeactivateAdminQuizMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeactivateAdminQuizMutation = { __typename?: 'Mutation', deactivateQuiz: { __typename?: 'QuizResponse', id: string, status: QuizStatus, updatedAt: any } };

export type RejectAdminQuizMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RejectAdminQuizMutation = { __typename?: 'Mutation', rejectQuiz: { __typename?: 'QuizResponse', id: string, status: QuizStatus, updatedAt: any } };

export type GetAdminQuizDifficultiesQueryVariables = Exact<{
  includeInactive: Scalars['Boolean'];
}>;


export type GetAdminQuizDifficultiesQuery = { __typename?: 'Query', difficulties: Array<{ __typename?: 'DifficultyResponse', id: string, code: string, label: string, points: number, order: number, isActive: boolean, createdAt: any, updatedAt: any }> };

export type GetAdminQuizDifficultyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAdminQuizDifficultyQuery = { __typename?: 'Query', difficulty: { __typename?: 'DifficultyResponse', id: string, code: string, label: string, points: number, order: number, isActive: boolean, createdAt: any, updatedAt: any } };

export type CreateAdminQuizDifficultyMutationVariables = Exact<{
  input: CreateDifficultyInput;
}>;


export type CreateAdminQuizDifficultyMutation = { __typename?: 'Mutation', createDifficulty: { __typename?: 'DifficultyResponse', id: string, code: string, label: string, points: number, order: number, isActive: boolean, createdAt: any, updatedAt: any } };

export type UpdateAdminQuizDifficultyMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateDifficultyInput;
}>;


export type UpdateAdminQuizDifficultyMutation = { __typename?: 'Mutation', updateDifficulty: { __typename?: 'DifficultyResponse', id: string, code: string, label: string, points: number, order: number, isActive: boolean, updatedAt: any } };

export type DeactivateAdminQuizDifficultyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeactivateAdminQuizDifficultyMutation = { __typename?: 'Mutation', deactivateDifficulty: { __typename?: 'DifficultyResponse', id: string, isActive: boolean, updatedAt: any } };

export type GetAdminQuizSourceMaterialsQueryVariables = Exact<{
  search?: InputMaybe<SourceMaterialSearchInput>;
  pagination?: InputMaybe<SourceMaterialPaginationInput>;
}>;


export type GetAdminQuizSourceMaterialsQuery = { __typename?: 'Query', sourceMaterials: { __typename?: 'PaginatedSourceMaterialResponse', items: Array<{ __typename?: 'SourceMaterialResponse', id: string, title: string, contentType: string, fileSize?: number | null, uploadStatus: UploadStatus, createdAt: any, updatedAt: any, createdBy?: string | null }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, total: number, totalPages: number } } };

export type GetAdminQuizSourceMaterialQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAdminQuizSourceMaterialQuery = { __typename?: 'Query', sourceMaterial: { __typename?: 'SourceMaterialResponse', id: string, title: string, contentType: string, fileSize?: number | null, uploadStatus: UploadStatus, createdAt: any, updatedAt: any, createdBy?: string | null, generationHistory: Array<{ __typename?: 'GenerationJobSummary', id: string, status: GenerationJobStatus, generatedCount: number, requestedAt: any, finishedAt?: any | null }> } };

export type GetAdminQuizSourceMaterialDownloadUrlQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAdminQuizSourceMaterialDownloadUrlQuery = { __typename?: 'Query', getSourceMaterialDownloadUrl?: string | null };

export type CreateAdminQuizSourceMaterialMutationVariables = Exact<{
  input: CreateSourceMaterialInput;
}>;


export type CreateAdminQuizSourceMaterialMutation = { __typename?: 'Mutation', createSourceMaterial: { __typename?: 'CreateSourceMaterialResponse', id: string, uploadUrl: string, expiresAt: string } };

export type FinalizeAdminQuizSourceMaterialUploadMutationVariables = Exact<{
  input: FinalizeUploadInput;
}>;


export type FinalizeAdminQuizSourceMaterialUploadMutation = { __typename?: 'Mutation', finalizeSourceMaterialUpload: { __typename?: 'SourceMaterialResponse', id: string, title: string, contentType: string, fileSize?: number | null, uploadStatus: UploadStatus, createdAt: any, updatedAt: any } };

export type UpdateAdminQuizSourceMaterialMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateSourceMaterialInput;
}>;


export type UpdateAdminQuizSourceMaterialMutation = { __typename?: 'Mutation', updateSourceMaterial: { __typename?: 'SourceMaterialResponse', id: string, title: string, contentType: string, fileSize?: number | null, uploadStatus: UploadStatus, createdAt: any, updatedAt: any } };

export type DeleteAdminQuizSourceMaterialMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAdminQuizSourceMaterialMutation = { __typename?: 'Mutation', deleteSourceMaterial: boolean };

export type RetryAdminQuizSourceMaterialUploadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RetryAdminQuizSourceMaterialUploadMutation = { __typename?: 'Mutation', retrySourceMaterialUpload: { __typename?: 'CreateSourceMaterialResponse', id: string, uploadUrl: string, expiresAt: string } };

export type GenerateAdminQuizzesMutationVariables = Exact<{
  input: GenerateQuizInput;
}>;


export type GenerateAdminQuizzesMutation = { __typename?: 'Mutation', generateQuizzes: { __typename?: 'GenerateQuizResponse', jobId: string, status: string, message: string } };


export const GetAdminQuizzesDocument = gql`
    query GetAdminQuizzes($search: QuizSearchInput, $filter: QuizFilterInput, $pagination: PaginationInput, $sort: QuizSortInput) {
  quizzes(search: $search, filter: $filter, pagination: $pagination, sort: $sort) {
    items {
      id
      stem
      type
      difficultyLevel {
        id
        code
        label
        order
        points
      }
      awardedPoints
      status
      sourceMaterialId
      generationJobId
      createdAt
      updatedAt
      updatedBy
    }
    meta {
      page
      limit
      total
      totalPages
    }
  }
}
    `;

/**
 * __useGetAdminQuizzesQuery__
 *
 * To run a query within a React component, call `useGetAdminQuizzesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminQuizzesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminQuizzesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAdminQuizzesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminQuizzesQuery, GetAdminQuizzesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminQuizzesQuery, GetAdminQuizzesQueryVariables>(GetAdminQuizzesDocument, options);
      }
export function useGetAdminQuizzesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminQuizzesQuery, GetAdminQuizzesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminQuizzesQuery, GetAdminQuizzesQueryVariables>(GetAdminQuizzesDocument, options);
        }
export type GetAdminQuizzesQueryHookResult = ReturnType<typeof useGetAdminQuizzesQuery>;
export type GetAdminQuizzesLazyQueryHookResult = ReturnType<typeof useGetAdminQuizzesLazyQuery>;
export type GetAdminQuizzesQueryResult = Apollo.QueryResult<GetAdminQuizzesQuery, GetAdminQuizzesQueryVariables>;
export const GetAdminQuizDocument = gql`
    query GetAdminQuiz($id: ID!) {
  quiz(id: $id) {
    id
    stem
    type
    difficultyLevel {
      id
      code
      label
      order
      points
    }
    awardedPoints
    status
    explanation
    hint
    sourceMaterialId
    generationJobId
    choices {
      id
      label
      text
      isCorrect
    }
    shortAnswerSpec {
      acceptableAnswers
      typoTolerance
    }
    createdAt
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useGetAdminQuizQuery__
 *
 * To run a query within a React component, call `useGetAdminQuizQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminQuizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminQuizQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminQuizQuery(baseOptions: Apollo.QueryHookOptions<GetAdminQuizQuery, GetAdminQuizQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminQuizQuery, GetAdminQuizQueryVariables>(GetAdminQuizDocument, options);
      }
export function useGetAdminQuizLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminQuizQuery, GetAdminQuizQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminQuizQuery, GetAdminQuizQueryVariables>(GetAdminQuizDocument, options);
        }
export type GetAdminQuizQueryHookResult = ReturnType<typeof useGetAdminQuizQuery>;
export type GetAdminQuizLazyQueryHookResult = ReturnType<typeof useGetAdminQuizLazyQuery>;
export type GetAdminQuizQueryResult = Apollo.QueryResult<GetAdminQuizQuery, GetAdminQuizQueryVariables>;
export const GetAdminActiveQuizzesDocument = gql`
    query GetAdminActiveQuizzes {
  activeQuizzes {
    id
    stem
    type
    difficultyLevel {
      id
      code
      label
      order
      points
    }
    awardedPoints
    status
    sourceMaterialId
    generationJobId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAdminActiveQuizzesQuery__
 *
 * To run a query within a React component, call `useGetAdminActiveQuizzesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminActiveQuizzesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminActiveQuizzesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminActiveQuizzesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminActiveQuizzesQuery, GetAdminActiveQuizzesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminActiveQuizzesQuery, GetAdminActiveQuizzesQueryVariables>(GetAdminActiveQuizzesDocument, options);
      }
export function useGetAdminActiveQuizzesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminActiveQuizzesQuery, GetAdminActiveQuizzesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminActiveQuizzesQuery, GetAdminActiveQuizzesQueryVariables>(GetAdminActiveQuizzesDocument, options);
        }
export type GetAdminActiveQuizzesQueryHookResult = ReturnType<typeof useGetAdminActiveQuizzesQuery>;
export type GetAdminActiveQuizzesLazyQueryHookResult = ReturnType<typeof useGetAdminActiveQuizzesLazyQuery>;
export type GetAdminActiveQuizzesQueryResult = Apollo.QueryResult<GetAdminActiveQuizzesQuery, GetAdminActiveQuizzesQueryVariables>;
export const GetAdminDraftQuizzesDocument = gql`
    query GetAdminDraftQuizzes {
  draftQuizzes {
    id
    stem
    type
    difficultyLevel {
      id
      code
      label
      order
      points
    }
    awardedPoints
    status
    sourceMaterialId
    generationJobId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAdminDraftQuizzesQuery__
 *
 * To run a query within a React component, call `useGetAdminDraftQuizzesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDraftQuizzesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDraftQuizzesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminDraftQuizzesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminDraftQuizzesQuery, GetAdminDraftQuizzesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminDraftQuizzesQuery, GetAdminDraftQuizzesQueryVariables>(GetAdminDraftQuizzesDocument, options);
      }
export function useGetAdminDraftQuizzesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminDraftQuizzesQuery, GetAdminDraftQuizzesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminDraftQuizzesQuery, GetAdminDraftQuizzesQueryVariables>(GetAdminDraftQuizzesDocument, options);
        }
export type GetAdminDraftQuizzesQueryHookResult = ReturnType<typeof useGetAdminDraftQuizzesQuery>;
export type GetAdminDraftQuizzesLazyQueryHookResult = ReturnType<typeof useGetAdminDraftQuizzesLazyQuery>;
export type GetAdminDraftQuizzesQueryResult = Apollo.QueryResult<GetAdminDraftQuizzesQuery, GetAdminDraftQuizzesQueryVariables>;
export const CreateAdminQuizDocument = gql`
    mutation CreateAdminQuiz($input: CreateQuizInput!) {
  createQuiz(input: $input) {
    id
    stem
    type
    difficultyLevel {
      id
      code
      label
      order
      points
    }
    awardedPoints
    status
    explanation
    hint
    sourceMaterialId
    choices {
      id
      label
      text
      isCorrect
    }
    shortAnswerSpec {
      acceptableAnswers
      typoTolerance
    }
    createdAt
    updatedAt
  }
}
    `;
export type CreateAdminQuizMutationFn = Apollo.MutationFunction<CreateAdminQuizMutation, CreateAdminQuizMutationVariables>;

/**
 * __useCreateAdminQuizMutation__
 *
 * To run a mutation, you first call `useCreateAdminQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminQuizMutation, { data, loading, error }] = useCreateAdminQuizMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminQuizMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminQuizMutation, CreateAdminQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminQuizMutation, CreateAdminQuizMutationVariables>(CreateAdminQuizDocument, options);
      }
export type CreateAdminQuizMutationHookResult = ReturnType<typeof useCreateAdminQuizMutation>;
export type CreateAdminQuizMutationResult = Apollo.MutationResult<CreateAdminQuizMutation>;
export type CreateAdminQuizMutationOptions = Apollo.BaseMutationOptions<CreateAdminQuizMutation, CreateAdminQuizMutationVariables>;
export const UpdateAdminQuizDocument = gql`
    mutation UpdateAdminQuiz($id: ID!, $input: UpdateQuizInput!) {
  updateQuiz(id: $id, input: $input) {
    id
    stem
    type
    difficultyLevel {
      id
      code
      label
      order
      points
    }
    awardedPoints
    status
    explanation
    hint
    sourceMaterialId
    choices {
      id
      label
      text
      isCorrect
    }
    shortAnswerSpec {
      acceptableAnswers
      typoTolerance
    }
    createdAt
    updatedAt
  }
}
    `;
export type UpdateAdminQuizMutationFn = Apollo.MutationFunction<UpdateAdminQuizMutation, UpdateAdminQuizMutationVariables>;

/**
 * __useUpdateAdminQuizMutation__
 *
 * To run a mutation, you first call `useUpdateAdminQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminQuizMutation, { data, loading, error }] = useUpdateAdminQuizMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminQuizMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminQuizMutation, UpdateAdminQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminQuizMutation, UpdateAdminQuizMutationVariables>(UpdateAdminQuizDocument, options);
      }
export type UpdateAdminQuizMutationHookResult = ReturnType<typeof useUpdateAdminQuizMutation>;
export type UpdateAdminQuizMutationResult = Apollo.MutationResult<UpdateAdminQuizMutation>;
export type UpdateAdminQuizMutationOptions = Apollo.BaseMutationOptions<UpdateAdminQuizMutation, UpdateAdminQuizMutationVariables>;
export const DeleteAdminQuizDocument = gql`
    mutation DeleteAdminQuiz($id: ID!) {
  deleteQuiz(id: $id)
}
    `;
export type DeleteAdminQuizMutationFn = Apollo.MutationFunction<DeleteAdminQuizMutation, DeleteAdminQuizMutationVariables>;

/**
 * __useDeleteAdminQuizMutation__
 *
 * To run a mutation, you first call `useDeleteAdminQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminQuizMutation, { data, loading, error }] = useDeleteAdminQuizMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminQuizMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdminQuizMutation, DeleteAdminQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdminQuizMutation, DeleteAdminQuizMutationVariables>(DeleteAdminQuizDocument, options);
      }
export type DeleteAdminQuizMutationHookResult = ReturnType<typeof useDeleteAdminQuizMutation>;
export type DeleteAdminQuizMutationResult = Apollo.MutationResult<DeleteAdminQuizMutation>;
export type DeleteAdminQuizMutationOptions = Apollo.BaseMutationOptions<DeleteAdminQuizMutation, DeleteAdminQuizMutationVariables>;
export const ActivateAdminQuizDocument = gql`
    mutation ActivateAdminQuiz($id: ID!) {
  activateQuiz(id: $id) {
    id
    status
    updatedAt
  }
}
    `;
export type ActivateAdminQuizMutationFn = Apollo.MutationFunction<ActivateAdminQuizMutation, ActivateAdminQuizMutationVariables>;

/**
 * __useActivateAdminQuizMutation__
 *
 * To run a mutation, you first call `useActivateAdminQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateAdminQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateAdminQuizMutation, { data, loading, error }] = useActivateAdminQuizMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateAdminQuizMutation(baseOptions?: Apollo.MutationHookOptions<ActivateAdminQuizMutation, ActivateAdminQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateAdminQuizMutation, ActivateAdminQuizMutationVariables>(ActivateAdminQuizDocument, options);
      }
export type ActivateAdminQuizMutationHookResult = ReturnType<typeof useActivateAdminQuizMutation>;
export type ActivateAdminQuizMutationResult = Apollo.MutationResult<ActivateAdminQuizMutation>;
export type ActivateAdminQuizMutationOptions = Apollo.BaseMutationOptions<ActivateAdminQuizMutation, ActivateAdminQuizMutationVariables>;
export const DeactivateAdminQuizDocument = gql`
    mutation DeactivateAdminQuiz($id: ID!) {
  deactivateQuiz(id: $id) {
    id
    status
    updatedAt
  }
}
    `;
export type DeactivateAdminQuizMutationFn = Apollo.MutationFunction<DeactivateAdminQuizMutation, DeactivateAdminQuizMutationVariables>;

/**
 * __useDeactivateAdminQuizMutation__
 *
 * To run a mutation, you first call `useDeactivateAdminQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAdminQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAdminQuizMutation, { data, loading, error }] = useDeactivateAdminQuizMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateAdminQuizMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateAdminQuizMutation, DeactivateAdminQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateAdminQuizMutation, DeactivateAdminQuizMutationVariables>(DeactivateAdminQuizDocument, options);
      }
export type DeactivateAdminQuizMutationHookResult = ReturnType<typeof useDeactivateAdminQuizMutation>;
export type DeactivateAdminQuizMutationResult = Apollo.MutationResult<DeactivateAdminQuizMutation>;
export type DeactivateAdminQuizMutationOptions = Apollo.BaseMutationOptions<DeactivateAdminQuizMutation, DeactivateAdminQuizMutationVariables>;
export const RejectAdminQuizDocument = gql`
    mutation RejectAdminQuiz($id: ID!) {
  rejectQuiz(id: $id) {
    id
    status
    updatedAt
  }
}
    `;
export type RejectAdminQuizMutationFn = Apollo.MutationFunction<RejectAdminQuizMutation, RejectAdminQuizMutationVariables>;

/**
 * __useRejectAdminQuizMutation__
 *
 * To run a mutation, you first call `useRejectAdminQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectAdminQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectAdminQuizMutation, { data, loading, error }] = useRejectAdminQuizMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRejectAdminQuizMutation(baseOptions?: Apollo.MutationHookOptions<RejectAdminQuizMutation, RejectAdminQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectAdminQuizMutation, RejectAdminQuizMutationVariables>(RejectAdminQuizDocument, options);
      }
export type RejectAdminQuizMutationHookResult = ReturnType<typeof useRejectAdminQuizMutation>;
export type RejectAdminQuizMutationResult = Apollo.MutationResult<RejectAdminQuizMutation>;
export type RejectAdminQuizMutationOptions = Apollo.BaseMutationOptions<RejectAdminQuizMutation, RejectAdminQuizMutationVariables>;
export const GetAdminQuizDifficultiesDocument = gql`
    query GetAdminQuizDifficulties($includeInactive: Boolean!) {
  difficulties(includeInactive: $includeInactive) {
    id
    code
    label
    points
    order
    isActive
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAdminQuizDifficultiesQuery__
 *
 * To run a query within a React component, call `useGetAdminQuizDifficultiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminQuizDifficultiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminQuizDifficultiesQuery({
 *   variables: {
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetAdminQuizDifficultiesQuery(baseOptions: Apollo.QueryHookOptions<GetAdminQuizDifficultiesQuery, GetAdminQuizDifficultiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminQuizDifficultiesQuery, GetAdminQuizDifficultiesQueryVariables>(GetAdminQuizDifficultiesDocument, options);
      }
export function useGetAdminQuizDifficultiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminQuizDifficultiesQuery, GetAdminQuizDifficultiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminQuizDifficultiesQuery, GetAdminQuizDifficultiesQueryVariables>(GetAdminQuizDifficultiesDocument, options);
        }
export type GetAdminQuizDifficultiesQueryHookResult = ReturnType<typeof useGetAdminQuizDifficultiesQuery>;
export type GetAdminQuizDifficultiesLazyQueryHookResult = ReturnType<typeof useGetAdminQuizDifficultiesLazyQuery>;
export type GetAdminQuizDifficultiesQueryResult = Apollo.QueryResult<GetAdminQuizDifficultiesQuery, GetAdminQuizDifficultiesQueryVariables>;
export const GetAdminQuizDifficultyDocument = gql`
    query GetAdminQuizDifficulty($id: ID!) {
  difficulty(id: $id) {
    id
    code
    label
    points
    order
    isActive
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAdminQuizDifficultyQuery__
 *
 * To run a query within a React component, call `useGetAdminQuizDifficultyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminQuizDifficultyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminQuizDifficultyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminQuizDifficultyQuery(baseOptions: Apollo.QueryHookOptions<GetAdminQuizDifficultyQuery, GetAdminQuizDifficultyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminQuizDifficultyQuery, GetAdminQuizDifficultyQueryVariables>(GetAdminQuizDifficultyDocument, options);
      }
export function useGetAdminQuizDifficultyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminQuizDifficultyQuery, GetAdminQuizDifficultyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminQuizDifficultyQuery, GetAdminQuizDifficultyQueryVariables>(GetAdminQuizDifficultyDocument, options);
        }
export type GetAdminQuizDifficultyQueryHookResult = ReturnType<typeof useGetAdminQuizDifficultyQuery>;
export type GetAdminQuizDifficultyLazyQueryHookResult = ReturnType<typeof useGetAdminQuizDifficultyLazyQuery>;
export type GetAdminQuizDifficultyQueryResult = Apollo.QueryResult<GetAdminQuizDifficultyQuery, GetAdminQuizDifficultyQueryVariables>;
export const CreateAdminQuizDifficultyDocument = gql`
    mutation CreateAdminQuizDifficulty($input: CreateDifficultyInput!) {
  createDifficulty(input: $input) {
    id
    code
    label
    points
    order
    isActive
    createdAt
    updatedAt
  }
}
    `;
export type CreateAdminQuizDifficultyMutationFn = Apollo.MutationFunction<CreateAdminQuizDifficultyMutation, CreateAdminQuizDifficultyMutationVariables>;

/**
 * __useCreateAdminQuizDifficultyMutation__
 *
 * To run a mutation, you first call `useCreateAdminQuizDifficultyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminQuizDifficultyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminQuizDifficultyMutation, { data, loading, error }] = useCreateAdminQuizDifficultyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminQuizDifficultyMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminQuizDifficultyMutation, CreateAdminQuizDifficultyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminQuizDifficultyMutation, CreateAdminQuizDifficultyMutationVariables>(CreateAdminQuizDifficultyDocument, options);
      }
export type CreateAdminQuizDifficultyMutationHookResult = ReturnType<typeof useCreateAdminQuizDifficultyMutation>;
export type CreateAdminQuizDifficultyMutationResult = Apollo.MutationResult<CreateAdminQuizDifficultyMutation>;
export type CreateAdminQuizDifficultyMutationOptions = Apollo.BaseMutationOptions<CreateAdminQuizDifficultyMutation, CreateAdminQuizDifficultyMutationVariables>;
export const UpdateAdminQuizDifficultyDocument = gql`
    mutation UpdateAdminQuizDifficulty($id: ID!, $input: UpdateDifficultyInput!) {
  updateDifficulty(id: $id, input: $input) {
    id
    code
    label
    points
    order
    isActive
    updatedAt
  }
}
    `;
export type UpdateAdminQuizDifficultyMutationFn = Apollo.MutationFunction<UpdateAdminQuizDifficultyMutation, UpdateAdminQuizDifficultyMutationVariables>;

/**
 * __useUpdateAdminQuizDifficultyMutation__
 *
 * To run a mutation, you first call `useUpdateAdminQuizDifficultyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminQuizDifficultyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminQuizDifficultyMutation, { data, loading, error }] = useUpdateAdminQuizDifficultyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminQuizDifficultyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminQuizDifficultyMutation, UpdateAdminQuizDifficultyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminQuizDifficultyMutation, UpdateAdminQuizDifficultyMutationVariables>(UpdateAdminQuizDifficultyDocument, options);
      }
export type UpdateAdminQuizDifficultyMutationHookResult = ReturnType<typeof useUpdateAdminQuizDifficultyMutation>;
export type UpdateAdminQuizDifficultyMutationResult = Apollo.MutationResult<UpdateAdminQuizDifficultyMutation>;
export type UpdateAdminQuizDifficultyMutationOptions = Apollo.BaseMutationOptions<UpdateAdminQuizDifficultyMutation, UpdateAdminQuizDifficultyMutationVariables>;
export const DeactivateAdminQuizDifficultyDocument = gql`
    mutation DeactivateAdminQuizDifficulty($id: ID!) {
  deactivateDifficulty(id: $id) {
    id
    isActive
    updatedAt
  }
}
    `;
export type DeactivateAdminQuizDifficultyMutationFn = Apollo.MutationFunction<DeactivateAdminQuizDifficultyMutation, DeactivateAdminQuizDifficultyMutationVariables>;

/**
 * __useDeactivateAdminQuizDifficultyMutation__
 *
 * To run a mutation, you first call `useDeactivateAdminQuizDifficultyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAdminQuizDifficultyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAdminQuizDifficultyMutation, { data, loading, error }] = useDeactivateAdminQuizDifficultyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateAdminQuizDifficultyMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateAdminQuizDifficultyMutation, DeactivateAdminQuizDifficultyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateAdminQuizDifficultyMutation, DeactivateAdminQuizDifficultyMutationVariables>(DeactivateAdminQuizDifficultyDocument, options);
      }
export type DeactivateAdminQuizDifficultyMutationHookResult = ReturnType<typeof useDeactivateAdminQuizDifficultyMutation>;
export type DeactivateAdminQuizDifficultyMutationResult = Apollo.MutationResult<DeactivateAdminQuizDifficultyMutation>;
export type DeactivateAdminQuizDifficultyMutationOptions = Apollo.BaseMutationOptions<DeactivateAdminQuizDifficultyMutation, DeactivateAdminQuizDifficultyMutationVariables>;
export const GetAdminQuizSourceMaterialsDocument = gql`
    query GetAdminQuizSourceMaterials($search: SourceMaterialSearchInput, $pagination: SourceMaterialPaginationInput) {
  sourceMaterials(search: $search, pagination: $pagination) {
    items {
      id
      title
      contentType
      fileSize
      uploadStatus
      createdAt
      updatedAt
      createdBy
    }
    meta {
      page
      limit
      total
      totalPages
    }
  }
}
    `;

/**
 * __useGetAdminQuizSourceMaterialsQuery__
 *
 * To run a query within a React component, call `useGetAdminQuizSourceMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminQuizSourceMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminQuizSourceMaterialsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAdminQuizSourceMaterialsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminQuizSourceMaterialsQuery, GetAdminQuizSourceMaterialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminQuizSourceMaterialsQuery, GetAdminQuizSourceMaterialsQueryVariables>(GetAdminQuizSourceMaterialsDocument, options);
      }
export function useGetAdminQuizSourceMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminQuizSourceMaterialsQuery, GetAdminQuizSourceMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminQuizSourceMaterialsQuery, GetAdminQuizSourceMaterialsQueryVariables>(GetAdminQuizSourceMaterialsDocument, options);
        }
export type GetAdminQuizSourceMaterialsQueryHookResult = ReturnType<typeof useGetAdminQuizSourceMaterialsQuery>;
export type GetAdminQuizSourceMaterialsLazyQueryHookResult = ReturnType<typeof useGetAdminQuizSourceMaterialsLazyQuery>;
export type GetAdminQuizSourceMaterialsQueryResult = Apollo.QueryResult<GetAdminQuizSourceMaterialsQuery, GetAdminQuizSourceMaterialsQueryVariables>;
export const GetAdminQuizSourceMaterialDocument = gql`
    query GetAdminQuizSourceMaterial($id: ID!) {
  sourceMaterial(id: $id) {
    id
    title
    contentType
    fileSize
    uploadStatus
    createdAt
    updatedAt
    createdBy
    generationHistory {
      id
      status
      generatedCount
      requestedAt
      finishedAt
    }
  }
}
    `;

/**
 * __useGetAdminQuizSourceMaterialQuery__
 *
 * To run a query within a React component, call `useGetAdminQuizSourceMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminQuizSourceMaterialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminQuizSourceMaterialQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminQuizSourceMaterialQuery(baseOptions: Apollo.QueryHookOptions<GetAdminQuizSourceMaterialQuery, GetAdminQuizSourceMaterialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminQuizSourceMaterialQuery, GetAdminQuizSourceMaterialQueryVariables>(GetAdminQuizSourceMaterialDocument, options);
      }
export function useGetAdminQuizSourceMaterialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminQuizSourceMaterialQuery, GetAdminQuizSourceMaterialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminQuizSourceMaterialQuery, GetAdminQuizSourceMaterialQueryVariables>(GetAdminQuizSourceMaterialDocument, options);
        }
export type GetAdminQuizSourceMaterialQueryHookResult = ReturnType<typeof useGetAdminQuizSourceMaterialQuery>;
export type GetAdminQuizSourceMaterialLazyQueryHookResult = ReturnType<typeof useGetAdminQuizSourceMaterialLazyQuery>;
export type GetAdminQuizSourceMaterialQueryResult = Apollo.QueryResult<GetAdminQuizSourceMaterialQuery, GetAdminQuizSourceMaterialQueryVariables>;
export const GetAdminQuizSourceMaterialDownloadUrlDocument = gql`
    query GetAdminQuizSourceMaterialDownloadUrl($id: ID!) {
  getSourceMaterialDownloadUrl(id: $id)
}
    `;

/**
 * __useGetAdminQuizSourceMaterialDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetAdminQuizSourceMaterialDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminQuizSourceMaterialDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminQuizSourceMaterialDownloadUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminQuizSourceMaterialDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetAdminQuizSourceMaterialDownloadUrlQuery, GetAdminQuizSourceMaterialDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminQuizSourceMaterialDownloadUrlQuery, GetAdminQuizSourceMaterialDownloadUrlQueryVariables>(GetAdminQuizSourceMaterialDownloadUrlDocument, options);
      }
export function useGetAdminQuizSourceMaterialDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminQuizSourceMaterialDownloadUrlQuery, GetAdminQuizSourceMaterialDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminQuizSourceMaterialDownloadUrlQuery, GetAdminQuizSourceMaterialDownloadUrlQueryVariables>(GetAdminQuizSourceMaterialDownloadUrlDocument, options);
        }
export type GetAdminQuizSourceMaterialDownloadUrlQueryHookResult = ReturnType<typeof useGetAdminQuizSourceMaterialDownloadUrlQuery>;
export type GetAdminQuizSourceMaterialDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetAdminQuizSourceMaterialDownloadUrlLazyQuery>;
export type GetAdminQuizSourceMaterialDownloadUrlQueryResult = Apollo.QueryResult<GetAdminQuizSourceMaterialDownloadUrlQuery, GetAdminQuizSourceMaterialDownloadUrlQueryVariables>;
export const CreateAdminQuizSourceMaterialDocument = gql`
    mutation CreateAdminQuizSourceMaterial($input: CreateSourceMaterialInput!) {
  createSourceMaterial(input: $input) {
    id
    uploadUrl
    expiresAt
  }
}
    `;
export type CreateAdminQuizSourceMaterialMutationFn = Apollo.MutationFunction<CreateAdminQuizSourceMaterialMutation, CreateAdminQuizSourceMaterialMutationVariables>;

/**
 * __useCreateAdminQuizSourceMaterialMutation__
 *
 * To run a mutation, you first call `useCreateAdminQuizSourceMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminQuizSourceMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminQuizSourceMaterialMutation, { data, loading, error }] = useCreateAdminQuizSourceMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminQuizSourceMaterialMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminQuizSourceMaterialMutation, CreateAdminQuizSourceMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminQuizSourceMaterialMutation, CreateAdminQuizSourceMaterialMutationVariables>(CreateAdminQuizSourceMaterialDocument, options);
      }
export type CreateAdminQuizSourceMaterialMutationHookResult = ReturnType<typeof useCreateAdminQuizSourceMaterialMutation>;
export type CreateAdminQuizSourceMaterialMutationResult = Apollo.MutationResult<CreateAdminQuizSourceMaterialMutation>;
export type CreateAdminQuizSourceMaterialMutationOptions = Apollo.BaseMutationOptions<CreateAdminQuizSourceMaterialMutation, CreateAdminQuizSourceMaterialMutationVariables>;
export const FinalizeAdminQuizSourceMaterialUploadDocument = gql`
    mutation FinalizeAdminQuizSourceMaterialUpload($input: FinalizeUploadInput!) {
  finalizeSourceMaterialUpload(input: $input) {
    id
    title
    contentType
    fileSize
    uploadStatus
    createdAt
    updatedAt
  }
}
    `;
export type FinalizeAdminQuizSourceMaterialUploadMutationFn = Apollo.MutationFunction<FinalizeAdminQuizSourceMaterialUploadMutation, FinalizeAdminQuizSourceMaterialUploadMutationVariables>;

/**
 * __useFinalizeAdminQuizSourceMaterialUploadMutation__
 *
 * To run a mutation, you first call `useFinalizeAdminQuizSourceMaterialUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeAdminQuizSourceMaterialUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeAdminQuizSourceMaterialUploadMutation, { data, loading, error }] = useFinalizeAdminQuizSourceMaterialUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizeAdminQuizSourceMaterialUploadMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeAdminQuizSourceMaterialUploadMutation, FinalizeAdminQuizSourceMaterialUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeAdminQuizSourceMaterialUploadMutation, FinalizeAdminQuizSourceMaterialUploadMutationVariables>(FinalizeAdminQuizSourceMaterialUploadDocument, options);
      }
export type FinalizeAdminQuizSourceMaterialUploadMutationHookResult = ReturnType<typeof useFinalizeAdminQuizSourceMaterialUploadMutation>;
export type FinalizeAdminQuizSourceMaterialUploadMutationResult = Apollo.MutationResult<FinalizeAdminQuizSourceMaterialUploadMutation>;
export type FinalizeAdminQuizSourceMaterialUploadMutationOptions = Apollo.BaseMutationOptions<FinalizeAdminQuizSourceMaterialUploadMutation, FinalizeAdminQuizSourceMaterialUploadMutationVariables>;
export const UpdateAdminQuizSourceMaterialDocument = gql`
    mutation UpdateAdminQuizSourceMaterial($id: ID!, $input: UpdateSourceMaterialInput!) {
  updateSourceMaterial(id: $id, input: $input) {
    id
    title
    contentType
    fileSize
    uploadStatus
    createdAt
    updatedAt
  }
}
    `;
export type UpdateAdminQuizSourceMaterialMutationFn = Apollo.MutationFunction<UpdateAdminQuizSourceMaterialMutation, UpdateAdminQuizSourceMaterialMutationVariables>;

/**
 * __useUpdateAdminQuizSourceMaterialMutation__
 *
 * To run a mutation, you first call `useUpdateAdminQuizSourceMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminQuizSourceMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminQuizSourceMaterialMutation, { data, loading, error }] = useUpdateAdminQuizSourceMaterialMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminQuizSourceMaterialMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminQuizSourceMaterialMutation, UpdateAdminQuizSourceMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminQuizSourceMaterialMutation, UpdateAdminQuizSourceMaterialMutationVariables>(UpdateAdminQuizSourceMaterialDocument, options);
      }
export type UpdateAdminQuizSourceMaterialMutationHookResult = ReturnType<typeof useUpdateAdminQuizSourceMaterialMutation>;
export type UpdateAdminQuizSourceMaterialMutationResult = Apollo.MutationResult<UpdateAdminQuizSourceMaterialMutation>;
export type UpdateAdminQuizSourceMaterialMutationOptions = Apollo.BaseMutationOptions<UpdateAdminQuizSourceMaterialMutation, UpdateAdminQuizSourceMaterialMutationVariables>;
export const DeleteAdminQuizSourceMaterialDocument = gql`
    mutation DeleteAdminQuizSourceMaterial($id: ID!) {
  deleteSourceMaterial(id: $id)
}
    `;
export type DeleteAdminQuizSourceMaterialMutationFn = Apollo.MutationFunction<DeleteAdminQuizSourceMaterialMutation, DeleteAdminQuizSourceMaterialMutationVariables>;

/**
 * __useDeleteAdminQuizSourceMaterialMutation__
 *
 * To run a mutation, you first call `useDeleteAdminQuizSourceMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminQuizSourceMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminQuizSourceMaterialMutation, { data, loading, error }] = useDeleteAdminQuizSourceMaterialMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminQuizSourceMaterialMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdminQuizSourceMaterialMutation, DeleteAdminQuizSourceMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdminQuizSourceMaterialMutation, DeleteAdminQuizSourceMaterialMutationVariables>(DeleteAdminQuizSourceMaterialDocument, options);
      }
export type DeleteAdminQuizSourceMaterialMutationHookResult = ReturnType<typeof useDeleteAdminQuizSourceMaterialMutation>;
export type DeleteAdminQuizSourceMaterialMutationResult = Apollo.MutationResult<DeleteAdminQuizSourceMaterialMutation>;
export type DeleteAdminQuizSourceMaterialMutationOptions = Apollo.BaseMutationOptions<DeleteAdminQuizSourceMaterialMutation, DeleteAdminQuizSourceMaterialMutationVariables>;
export const RetryAdminQuizSourceMaterialUploadDocument = gql`
    mutation RetryAdminQuizSourceMaterialUpload($id: ID!) {
  retrySourceMaterialUpload(id: $id) {
    id
    uploadUrl
    expiresAt
  }
}
    `;
export type RetryAdminQuizSourceMaterialUploadMutationFn = Apollo.MutationFunction<RetryAdminQuizSourceMaterialUploadMutation, RetryAdminQuizSourceMaterialUploadMutationVariables>;

/**
 * __useRetryAdminQuizSourceMaterialUploadMutation__
 *
 * To run a mutation, you first call `useRetryAdminQuizSourceMaterialUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryAdminQuizSourceMaterialUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryAdminQuizSourceMaterialUploadMutation, { data, loading, error }] = useRetryAdminQuizSourceMaterialUploadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetryAdminQuizSourceMaterialUploadMutation(baseOptions?: Apollo.MutationHookOptions<RetryAdminQuizSourceMaterialUploadMutation, RetryAdminQuizSourceMaterialUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryAdminQuizSourceMaterialUploadMutation, RetryAdminQuizSourceMaterialUploadMutationVariables>(RetryAdminQuizSourceMaterialUploadDocument, options);
      }
export type RetryAdminQuizSourceMaterialUploadMutationHookResult = ReturnType<typeof useRetryAdminQuizSourceMaterialUploadMutation>;
export type RetryAdminQuizSourceMaterialUploadMutationResult = Apollo.MutationResult<RetryAdminQuizSourceMaterialUploadMutation>;
export type RetryAdminQuizSourceMaterialUploadMutationOptions = Apollo.BaseMutationOptions<RetryAdminQuizSourceMaterialUploadMutation, RetryAdminQuizSourceMaterialUploadMutationVariables>;
export const GenerateAdminQuizzesDocument = gql`
    mutation GenerateAdminQuizzes($input: GenerateQuizInput!) {
  generateQuizzes(input: $input) {
    jobId
    status
    message
  }
}
    `;
export type GenerateAdminQuizzesMutationFn = Apollo.MutationFunction<GenerateAdminQuizzesMutation, GenerateAdminQuizzesMutationVariables>;

/**
 * __useGenerateAdminQuizzesMutation__
 *
 * To run a mutation, you first call `useGenerateAdminQuizzesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAdminQuizzesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAdminQuizzesMutation, { data, loading, error }] = useGenerateAdminQuizzesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAdminQuizzesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAdminQuizzesMutation, GenerateAdminQuizzesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAdminQuizzesMutation, GenerateAdminQuizzesMutationVariables>(GenerateAdminQuizzesDocument, options);
      }
export type GenerateAdminQuizzesMutationHookResult = ReturnType<typeof useGenerateAdminQuizzesMutation>;
export type GenerateAdminQuizzesMutationResult = Apollo.MutationResult<GenerateAdminQuizzesMutation>;
export type GenerateAdminQuizzesMutationOptions = Apollo.BaseMutationOptions<GenerateAdminQuizzesMutation, GenerateAdminQuizzesMutationVariables>;